import React, { useState } from 'react'
import { CountUp } from 'use-count-up'
import axios from 'axios'
import Modal from 'react-modal'
import { If, Then } from 'react-if'

function CommissionSection({ refreshPage, address, profitData }) {
    // const [showWithdrawForm, setShowWithdrawForm] = useState(false);
    const [showChangeForm, setShowChangeForm] = useState(false)

    // const [withdrawAmount, setWithdrawAmount] = useState('');
    const [changeCretaAmount, setChangeCretaAmount] = useState('')

    // const onChangeWithdrawAmount = (e) => {
    //     setWithdrawAmount(e.target.value);
    // }

    const onChangeCretaAmount = (e) => {
        setChangeCretaAmount(e.target.value)
    }

    const CountUpValue = (amount) => {
        if (amount === undefined || amount === 0 || amount === null) {
            return <CountUp end={0} thousandsSeparator="," />
        } else {
            return <CountUp isCounting start={0} end={amount} thousandsSeparator="," />
        }
    }

    /*
    function withdrawRequest(type){
        if(withdrawAmount === ''){
            alert("Please enter the amount.");
            return;
        }

        if(+withdrawAmount != Math.ceil(withdrawAmount)){
            alert("Please enter the quantity without decimal.");
            return;
        }           

        axios.post('api/withdrawRequest', {
            address: address,
            type: type,
            amount: +withdrawAmount,
        })
        .then((res) => {
            alert(res.data);
            refreshPage();
            setShowWithdrawForm(false);
            setWithdrawAmount('');
        })
        .catch((err) => {
            if(err.response){
                console.log(err.response);
                console.log(err.response.data.message);
                alert(err.response.data.message);
            }
            setWithdrawAmount('');
        })
    }   
    */

    function changeToCreta() {
        axios
            .post('api/changeCommissionToCreta', {
                address: address,
                usdt_amount: +changeCretaAmount,
            })
            .then((res) => {
                alert('Changed successfully.')
                setChangeCretaAmount('')
                refreshPage()
                setShowChangeForm(false)
            })
            .catch((err) => {
                if (err.response) {
                    console.log(err.response)
                    console.log(err.response.data.message)
                    alert(err.response.data.message)
                }
                setChangeCretaAmount('')
            })
    }

    function changePoint(type) {
        axios
            .post('api/changePoint', {
                address: address,
                type: type,
            })
            .then((res) => {
                alert('Changed successfully.')
                refreshPage()
            })
            .catch((err) => {
                if (err.response) {
                    console.log(err.response)
                    console.log(err.response.data.message)
                    alert(err.response.data.message)
                }
            })
    }

    return (
        <>
            <div className="withdraw-wrap">
                <div className="profit-title">Commissions</div>
                <div className="profit-wrap">
                    <div className="profit-header">
                        <p className="profit-name">Balance of commission </p>
                        <span className="profit-data profit-data-usdt">{CountUpValue(profitData.profit)}</span>
                    </div>

                    {/* <hr /> */}
                    <div className="flex-space-between">
                        {/* <button className="btn btn-secondary btn-shadow btn-md" onClick={() => setShowWithdrawForm(true)}>Withdraw</button>  */}
                        <div></div>
                        <button className="btn btn-secondary btn-shadow btn-md  ml-2" onClick={() => setShowChangeForm(true)}>
                            Change to CRETA
                        </button>
                    </div>

                    <hr />

                    {/* <div className="timeset color-gray">
                    Commission payments and withdrawal approvals are made only at 20:00 and 6:00 respectively everyday GMT standard
                </div> */}

                    {/* <hr /> */}
                    <div>
                        <div className="profit-header">
                            <p className="profit-name">Referral Commission</p>
                            <span className="profit-data">$ {CountUpValue(profitData.referral)}</span>
                        </div>
                        <If condition={profitData.referral > 0}>
                            <Then>
                                <div className="profit-body">
                                    <div className="btn-wrap">
                                        <button className="btn btn-sm btn-primary" onClick={() => changePoint('referral')}>
                                            Change
                                        </button>
                                    </div>
                                </div>
                            </Then>
                        </If>
                        <hr className="profit-hr" />

                        <div className="profit-header">
                            <p className="profit-name">Sponsor Commission</p>
                            <span className="profit-data">$ {CountUpValue(profitData.sponsor)}</span>
                        </div>
                        <If condition={profitData.sponsor > 0}>
                            <Then>
                                <div className="profit-body">
                                    <div className="btn-wrap">
                                        <button className="btn btn-sm btn-primary" onClick={() => changePoint('sponsor')}>
                                            Change
                                        </button>
                                    </div>
                                </div>
                            </Then>
                        </If>

                        <hr className="profit-hr" />

                        <div className="profit-header">
                            <p className="profit-name">Matching Commission</p>
                            <span className="profit-data">$ {CountUpValue(profitData.matching)}</span>
                        </div>
                        <If condition={profitData.matching > 0}>
                            <Then>
                                <div className="profit-body">
                                    <div className="btn-wrap">
                                        <button className="btn btn-sm btn-primary" onClick={() => changePoint('matching')}>
                                            Change
                                        </button>
                                    </div>
                                </div>
                            </Then>
                        </If>
                        {/* <hr className="profit-hr"/>
    
                    <div className="profit-header">
                        <p className="profit-name">Rank Commission</p>
                        <span className="profit-data">$ {CountUpValue(profitData.status)}</span>
                    </div>
                    <If condition={profitData.status > 0}>
                        <Then>
                            <div className="profit-body">
                                <div className="btn-wrap">
                                    <button className="btn btn-sm btn-primary" onClick={() => changePoint('status')}>Change</button>
                                </div>
                            </div>
                        </Then>
                    </If> */}
                    </div>
                </div>
            </div>

            {/* <Modal
            closeTimeoutMS={200}
            isOpen={showWithdrawForm}                    
            ariaHideApp={false}>        
            <div className="modal-body">
                <h2 className="mb-3">Withdraw Commission</h2>

                <div className="profit-header">
                    <p className="profit-name">Balance of commission </p>
                    <span className="profit-data profit-data-usdt">{CountUpValue(profitData.profit)}</span>
                </div>  
                <hr />
                <div>    
                    <input type="number" min="0" max={profitData.profit} value={withdrawAmount} placeholder="Amount" onChange={onChangeWithdrawAmount} />                
                </div>
                <p className="fee-text">Fee 0.5%, Minimum withdrawal Commission USDT 10.</p>    
                <hr />
                <div className="flex-space-between mt-3">
                    <button className="btn btn-md btn-secondary" onClick={() => setShowWithdrawForm(false)}>close</button>
                    <button className="btn btn-md btn-primary" onClick={() => withdrawRequest()}>Confirm</button>
                </div>
            </div>                       
        </Modal> */}
            <Modal closeTimeoutMS={200} isOpen={showChangeForm} ariaHideApp={false}>
                <div className="modal-body">
                    <h2 className="mb-3">Change to CRETA</h2>

                    <div className="profit-header">
                        <p className="profit-name">Balance of commission </p>
                        <span className="profit-data profit-data-usdt">{CountUpValue(profitData.profit)}</span>
                    </div>
                    <hr />
                    <div>
                        <input type="number" min="0" max={profitData.profit} value={changeCretaAmount} placeholder="Amount" onChange={onChangeCretaAmount} />
                    </div>

                    <hr />
                    <div className="flex-space-between mt-3">
                        <button className="btn btn-md btn-secondary" onClick={() => setShowChangeForm(false)}>
                            close
                        </button>
                        <button className="btn btn-md btn-primary" onClick={() => changeToCreta()}>
                            Confirm
                        </button>
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default CommissionSection
